import type { Operaciones, Rol } from '../../api/operaciones';
import type { Sede, TransferenciaPendiente } from '../../api/ops/equipo';
import type { MostrarAviso } from '../../componentes/avisoBreve';
import type { Permisos } from '../../permisos/permisos';

/** Lo que comparten los apartados de Equipo. */
export interface ContextoEquipo {
    ops: Operaciones;
    negocio: string;
    nombreNegocio: string;
    movil: boolean;
    soloLectura: boolean;
    /** Miembro de quien mira (para «Tú» y para no retirarse a sí mismo). */
    yo: string | null;
    /** Quien mira es el propietario. */
    soyPropietario: boolean;
    permisos: Permisos;
    avisar: MostrarAviso;
    /** Roles del negocio (listRoles), para marcar los de un miembro o una invitación. */
    roles: readonly Rol[];
    /** Sedes activas (listLocations), para las de un miembro y la de una tablet (G212). */
    sedes: readonly Sede[];
    /** Transferencia de la propiedad pendiente (`pending_ownership_transfer` de getBusiness), o null. */
    transferencia: TransferenciaPendiente | null;
    /** Zona horaria del negocio (`timezone` de getBusiness): la hora del bloqueo del PIN se enseña en ella (G362). */
    zonaHoraria: string | null;
    /** Algo ha cambiado: vuelve a pedir las cifras, los roles y la transferencia. */
    refrescar: () => void;
    /** Algo que se ve en el marco ha cambiado (mis roles, la propiedad): getMe y el menú de nuevo. */
    recargarMarco: () => void;
}

export const PERMISOS = {
    ver: 'equipo.miembros.ver',
    gestionar: 'equipo.miembros.gestionar',
    roles: 'equipo.roles.gestionar',
    tablets: 'equipo.tablets.gestionar',
    transferir: 'negocio.propiedad.transferir',
    negocio: 'negocio.ver',
} as const;
